import React, { useEffect } from "react";
import {
  Empty,
  Header,
  Loading,
  Separator,
  CartItemCard,
  ConfirmAlert,
  ListContainer,
  FullScreenLoading,
} from "component";
import FooterScreenCartSummary from "screen/shared/FooterScreenCartSummary";

import { mq } from "utils";
import { strings } from "asset/constant";

import { cartAtom } from "store";
import { useRecoilValue } from "recoil";

import { useFlag, useInitialLoading } from "hook";
import { useCart, useCartCompletion } from "client/api";
import Company from "./Company";
import { ScrollView, View } from "react-native";
import CompletionAlertCard from "./CompletionAlertCard";
import { css } from "style";

export default function Cart() {
  const { initialLoading } = useInitialLoading();

  const { refetch: cartRefetch } = useCart();
  const cart = useRecoilValue(cartAtom);

  const { flg: doneAlert, on: showDoneAlert, off: hideDoneAlert } = useFlag();
  const cartCompletionMut = useCartCompletion();

  const _onCartCompletion = (description: string) =>
    cartCompletionMut.mutate({ description });

  useEffect(() => {
    cartRefetch();
  }, [cartRefetch]);

  const _renderContent = () => {
    if (initialLoading) {
      return <Loading />;
    }

    if (!cart || cart.products.length === 0) {
      return <Empty message="سبد خرید شما خالی است" />;
    }

    return (
      <>
        <Company company={cart?.company} />

        <ScrollView
          keyboardShouldPersistTaps="always"
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{
            ...css.growContainer,
            paddingVertical: 10,
          }}
        >
          <View style={{ paddingTop: mq(15) }} />
          <View style={{ ...css.wrap, ...css.rRowCenterAlignSpaceBetween }}>
            {cart?.products.map((item, key) => {
              return (
                <View key={String(key)} style={css.responsiveBoxContainer}>
                  <CartItemCard item={item} />
                </View>
              );
            })}
          </View>
          <Separator transparent weight={mq(10)} />
        </ScrollView>

        {cart && cart?.products?.length > 0 && (
          <FooterScreenCartSummary
            button={{
              title: strings.complete_the_purchase,
              icon: { name: "check" },
              onPress: showDoneAlert,
            }}
          />
        )}

        <ConfirmAlert
          force
          show={doneAlert}
          hide={hideDoneAlert}
          renderContent={(close) => (
            <CompletionAlertCard
              close={close}
              onConfirm={(desc) => {
                close();
                _onCartCompletion(desc);
              }}
            />
          )}
        />

        {cartCompletionMut.isLoading && <FullScreenLoading />}
      </>
    );
  };

  return (
    <>
      <Header title={strings.cart} />
      {_renderContent()}
    </>
  );
}
